export default "__VITE_ASSET__soN8W1sk__"